import * as XLSX from "xlsx";
import { translate as t } from "../../infrastructure/translate/localization";

export default function generateUploadEmployeesSpreadsheetTemplate() {
  const wb = XLSX.utils.book_new();
  const sheetName = "Sheet 1";
  wb.SheetNames.push(sheetName);
  const headerKeys = [
    t("spreadsheet-headers.name"),
    t("spreadsheet-headers.surname-first"),
    t("spreadsheet-headers.surname-second"),
    t("spreadsheet-headers.email"),
    t("spreadsheet-headers.nif"),
    t("spreadsheet-headers.annual-gross-salary"),
    `${t("spreadsheet-headers.internal-id")} ${t(
      "spreadsheet-headers.optional"
    )}`,
    `${t("spreadsheet-headers.cost-center")} ${t(
      "spreadsheet-headers.optional"
    )}`,
    `${t("spreadsheet-headers.subsidiary")} ${t(
      "spreadsheet-headers.optional"
    )}`,
    t("spreadsheet-headers.hiring-date"),
  ];
  const values = [
    [
      "Juan Ramon",
      "Perez",
      "De Alta",
      "jra@email.com",
      "0000000T",
      36000,
      "ID-000001",
      "Marketing",
      "Demo Filial S.L.",
      "2020-05-20",
    ],
    [
      "María",
      "García",
      "Sera",
      "mg@email.com",
      "11111111H",
      "23000",
      "",
      "Tecnlogía",
      "",
      "2021-01-20",
    ],
  ];
  const wbData = [headerKeys, ...values];
  wb.Sheets[sheetName] = XLSX.utils.aoa_to_sheet(wbData);

  XLSX.writeFile(
    wb,
    `${t("spreadsheet-headers.employee-spreadsheet-upload-filename")}.xlsx`,
    { bookType: "xlsx", type: "binary" }
  );
}
